export const TRUNCATION_LIMIT = 300;
export const POST_TEXT_PREVIEW_MAX_LINES = 6;

/** Shared by the anchors in post content and the inline "more" control, which reads as a link. */
export const INLINE_LINK_CLASSNAME = 'cursor-pointer text-brand transition-colors hover:text-brand/80';
